import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({})
class ErrorCapture extends Vue {
  // errorCaptured(error: any) {
  //   if (error.statusCode !== 404) {
  //     console.error('errorCaptured', error)
  //     this.$sentry.captureException(error)
  //   }
  //   // error is 404, so we don't want to capture it
  //   return true
  // }
}

export default toNative(ErrorCapture)
